import { GeneralRoutes } from './general.routes';

export const ClientRoutes = [...GeneralRoutes];
